export const headCellCashCardProductInSite = [
  { id: "id", disablePadding: false, label: "Id" },
  { id: "name", disablePadding: false, label: "Compañia" },
  { id: "barCode", disablePadding: false, label: "Código de barras" },
  { id: "amount", disablePadding: false, label: "Monto" },
  { id: "add", disablePadding: false, label: "Agregar a carrito" },
];
